import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';

// Resolves the chart title for the currently selected grouped-dropdown section
// and publishes it to ChartLayout. Headless on purpose: ChartLayout keeps the
// <h3>, and holding the resolved string there lets the exported image title and
// the download filename use it too — rendering the text here would have left
// those reading the un-overridden title.
//
// A section can plot a different metric than the rest of the chart — the
// inference benchmark's agentic rows carry only a P90 interactivity, so the axis
// switches silently and the title would otherwise still promise the default one.
// Sections without a title of their own resolve to null, and ChartLayout keeps
// the group's own title.
export default function ChartTitleProbe({ currentGroup, onResolve }) {
  const { filters } = useSearch();

  const sections = React.useMemo(
    () => (currentGroup?.filters || [])
      .filter(filter => filter.kind === 'grouped-dropdown')
      .flatMap(filter => filter.sections || [])
      // `label` as well as `field`: groupedOptionsOf skips a section without one,
      // so a section that contributes no option to the dropdown must not be able
      // to win the title either.
      .filter(section => section?.field && section?.label && section?.title),
    [currentGroup]
  );

  const active = sections.find(section => filters?.some(f => f.field === section.field));
  const resolved = active ? active.title : null;

  React.useEffect(() => { onResolve(resolved); }, [resolved, onResolve]);

  return null;
}
